module.exports = __webpack_public_path__ + "img/Brunei Darussalam.bb184c04.svg";